import { useMutation } from '@tanstack/react-query';

import { storage } from '@hero/utils';

import { organizationServices } from '../../index';

export const useLoginWithCode = () =>
  useMutation(params => organizationServices.signInWithCode(params), {
    onSuccess(res) {
      storage.setUserToken(res.token);
    }
  });

export const useSetOrganization = () =>
  useMutation(
    organizationCode => {
      storage.setOrganizationCode(organizationCode);
      return organizationServices.selectOrganization({
        organizationCode
      });
    },
    {
      onSuccess: data => {
        storage.setUserToken(data.token, {
          expires: new Date(data.tokenExpiresAt)
        });
      }
    }
  );
